// src/components/ClcBar.js
import React from "react";

const ClcBar = ({ data }) => {
  const getClcStyle = (percentage) => {
    if (percentage <= 0) {
      return { display: "none" };
    }
    return { width: `${percentage}%` };
  };

  return (
    <div className="d-flex graphSectionRow clc-bar">
      <div
        className=" summary_clc_bar overallPerformancesBar excel"
        style={getClcStyle(data.cognitive_competence_score_excel)}
      ></div>
      <div
        className="summary_clc_bar overallPerformancesBar competent"
        style={getClcStyle(data.cognitive_competence_score_competent)}
      ></div>
      <div
        className="summary_clc_bar overallPerformancesBar unsure"
        style={getClcStyle(data.cognitive_competence_score_unsure)}
      ></div>
      <div
        className="summary_clc_bar overallPerformancesBar novice"
        style={getClcStyle(data.cognitive_competence_score_novice)}
      ></div>
      <div
        className="summary_clc_bar overallPerformancesBar warning"
        style={getClcStyle(data.cognitive_competence_score_warning)}
      ></div>
    </div>
  );
};

export default ClcBar;
